import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Wallet, Coins, Rocket, X, Clock } from "lucide-react";

const PUMP_URL = "https://pump.fun/coin/CXo4dUwJw6D2m4ELeXZfyNnro4bc8sJJ4WtGcxAipump";

const STEPS = [
  {
    n: "01",
    Icon: Wallet,
    title: "Get a Solana wallet",
    body: "Install Phantom (mobile or browser) in ~30 seconds. It holds your $BBM and SOL.",
    hint: "phantom.com",
  },
  {
    n: "02",
    Icon: Coins,
    title: "Fund it with SOL",
    body: "Buy SOL inside Phantom with a card, or send from any exchange (Coinbase, Kraken, Binance).",
    hint: "$10 minimum",
  },
  {
    n: "03",
    Icon: Rocket,
    title: "Swap for $BBM",
    body: "Hit the button below to open the $BBM page on pump.fun. Connect wallet → Buy. That's it.",
    hint: "Powers Black Box Radio",
  },
];

const BuyBBMOnboardingModal = ({ open, onOpenChange }) => {
  const close = () => onOpenChange?.(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="bbm-onboarding-modal"
        className="max-w-[560px] border border-[#A855F7]/40 bg-black/95 p-0 text-[#FAFAFA] shadow-[0_0_60px_rgba(168,85,247,0.25)]"
      >
        <DialogTitle className="sr-only">How to Buy $BBM in 60 seconds</DialogTitle>
        <button
          type="button"
          onClick={close}
          data-testid="bbm-onboarding-close"
          aria-label="Close"
          className="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center border border-white/10 bg-black/60 text-[#A1A1AA] transition-colors hover:border-[#A855F7] hover:text-[#FAFAFA]"
        >
          <X size={14} />
        </button>

        <div className="border-b border-white/10 px-6 pt-8 pb-6 sm:px-8">
          <div className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.28em] text-[#A855F7]">
            <Clock size={12} /> 60-second guide
          </div>
          <h2 className="mt-3 font-[Unbounded,sans-serif] text-2xl font-bold uppercase leading-tight sm:text-3xl">
            How to buy <span className="text-[#A855F7]">$BBM</span>
          </h2>
          <p className="mt-2 font-mono text-sm font-bold leading-relaxed text-[#A1A1AA]">
            Power Black Box Radio, join our movement, and unlock utility across access, rewards, governance and creator payouts.
          </p>
        </div>

        <div className="flex flex-col gap-3 px-6 py-6 sm:px-8">
          {STEPS.map(({ n, Icon, title, body, hint }) => (
            <div
              key={n}
              data-testid={`bbm-onboarding-step-${n}`}
              className="flex gap-4 border border-white/10 bg-black/50 p-4 backdrop-blur-sm"
            >
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center border border-[#A855F7]/60 bg-[#A855F7]/10 text-[#A855F7]">
                <Icon size={18} strokeWidth={2.25} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between">
                  <div className="font-mono text-xs font-bold uppercase tracking-[0.22em] text-[#A855F7]">
                    Step {n}
                  </div>
                  <div className="font-mono text-xs font-bold uppercase tracking-[0.18em] text-[#A1A1AA]">
                    {hint}
                  </div>
                </div>
                <div className="mt-1 font-[Unbounded,sans-serif] text-base font-bold text-[#FAFAFA]">
                  {title}
                </div>
                <p className="mt-1 font-mono text-sm font-bold leading-snug text-[#A1A1AA]">
                  {body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-white/10 bg-black/70 px-6 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <button
            type="button"
            onClick={close}
            data-testid="bbm-onboarding-later"
            className="font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#A1A1AA] transition-colors hover:text-[#FAFAFA]"
          >
            Maybe later
          </button>
          <a
            href={PUMP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
            data-testid="bbm-onboarding-cta"
            className="inline-flex items-center justify-center gap-2 border border-[#A855F7] bg-[#A855F7] px-6 py-3 font-[Unbounded,sans-serif] text-sm font-bold uppercase tracking-[0.22em] text-black transition-all hover:-translate-y-0.5 hover:bg-transparent hover:text-[#A855F7] hover:shadow-[0_0_24px_rgba(168,85,247,0.45)]"
          >
            <Rocket size={14} strokeWidth={2.5} /> Buy $BBM Now
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BuyBBMOnboardingModal;
